import styled from 'styled-components';
import { Direction } from 'src/components/tag-tooltip/Components/Anchor/types';

const getTrianglePosition = (direction) => {
  const positions = {
    [Direction.Left]: { top: '50%', left: '-11px', transform: 'translateY(-50%)' },
    [Direction.Right]: { top: '50%', left: '100%', transform: 'translateY(-50%) translateX(-1px)' },
    [Direction.Top]: { top: '-11px', left: '50%', transform: 'translateX(-50%)' },
    [Direction.Bottom]: {
      top: '100%',
      left: '50%',
      transform: 'translateX(-50%) translateY(-1px)',
    },
  };
  return positions[direction] || { display: 'none' };
};

const getTriangleStyles = (direction) => {
  const colors = { solid: '#000000a6', transparent: 'transparent' };
  return (
    {
      [Direction.Left]: {
        borderRight: `12px solid ${colors.solid}`,
        borderTop: '12px solid transparent',
        borderBottom: '12px solid transparent',
      },
      [Direction.Right]: {
        borderLeft: `12px solid ${colors.solid}`,
        borderTop: '12px solid transparent',
        borderBottom: '12px solid transparent',
      },
      [Direction.Top]: {
        borderBottom: `12px solid ${colors.solid}`,
        borderLeft: '12px solid transparent',
        borderRight: '12px solid transparent',
      },
      [Direction.Bottom]: {
        borderTop: `12px solid ${colors.solid}`,
        borderLeft: '12px solid transparent',
        borderRight: '12px solid transparent',
      },
    }[direction] || {}
  );
};

export const Wrapper = styled.div<{ width?: number; height?: number | string; visible?: boolean }>`
  position: fixed;
  z-index: 100;
  width: ${({ width }) => (width ? `${width}px` : '100vw')};
  height: ${({ height }) => (typeof height === 'string' ? height : `${height}px`)};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  background: transparent;
`;

Wrapper.defaultProps = {
  width: 380,
  height: 'auto',
  visible: true,
};

export const Triangle = styled.div<{ direction: Direction }>`
  position: absolute;
  width: 0;
  height: 0;
  ${({ direction }) => {
    const { top, left, transform } = getTrianglePosition(direction);
    return `top: ${top}; left: ${left}; transform: ${transform};`;
  }}
  ${({ direction }) => {
    const { borderLeft, borderRight, borderTop, borderBottom } = getTriangleStyles(direction);
    return `
      border-left: ${borderLeft || 'none'};
      border-right: ${borderRight || 'none'};
      border-top: ${borderTop || 'none'};
      border-bottom: ${borderBottom || 'none'};
    `;
  }}
`;

Triangle.defaultProps = {
  direction: Direction.Right,
};

export const Container = styled.div`
  color: white;
  display: flex;
  flex-direction: column;
  font-family: 'Heebo', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  border: 1px solid #ffffff1f;
  border-radius: 16px;
  overflow: hidden;
`;
